import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useMenu } from '../contexts/MenuContext';
import { formDataPost } from '../helpers/Helpers';
import withForm from '../layouts/withForm';

const SecurityInjectionGuardRequestsLog = ({handleChange}) => {  
    const {
        settingData
    } = useMenu();
    const methodList = ['GET','POST','PUT','PATCH','DELETE','HEAD','OPTIONS'];   
    // For data table
    const [selectedRows, setSelectedRows] = useState([])
    const [toggleCleared, setToggleCleared] = useState(false)

    const [bulkAction, setBulkAction] = useState("-1")
    const [tableData, setTableData] = useState([])
    const [filteredTableData, setFilteredTableData] = useState([])
    const [roleList, setRoleList] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [reloadDatatable, setReloadDatatable] = useState(0)
    const filterList = [
        { name: 'All', value: 'all' },
        { name: 'Allow', value: 'allow' },
        { name: 'Blocked', value: 'blocked' },
    ];    

    const [activeFilter, setActiveFilter] = useState('all')
    const columns = [
        {
            name: 'Path',
            selector: row => row.path,
            sortable: true,
        },
        {
            name: 'Query Param',
            selector: row => row.param,
            sortable: true,
        },
        {
            name: 'Timestamp',
            selector: row => row.date,
            sortable: true,
        },
        {
            name: 'Action',
            cell: row => (
                <select 
                    className="form-select"
                    value={row.blocked} 
                    onChange={() => toggleBlocked(row.id)}
                >
                    <option value="allow">Allow</option>
                    <option value="blocked">Blocked</option>
                </select>

            ),
        },
    ];
    const toggleBlocked = async (id) => {
        const updated = [...tableData];
        const index = updated.findIndex(row => row.id === id);
        handleChange(`security.url_guard.requests_log.${id}.blocked`, updated[index].blocked);
                    
        if (index !== -1) {
            updated[index].blocked = (updated[index].blocked == 'allow')?'blocked':'allow';

            try {
                const result = await formDataPost(
                    "ultimate_security_change_requests_log", 
                    {
                        'id':id, 
                        'status':updated[index].blocked
                    }
                );
                // console.log('result: ',result) 
                if (result.success) {
                    setTableData(updated);
                    setFilteredTableData(updated); // If you're filtering
                }
                    
                // setReload(prev => !prev); // Trigger reload to force re-render
            } catch (error) {
                console.log(error.message);
            } finally {} 

            
        }
    };

    // Get roles data
    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        
        const getRoleData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-roles`,
                    method: 'GET'
                });
        
                const rolesArray = Object.entries(response).map(([key, value]) => ({
                    role: key,
                    ...value
                }));
        
                setRoleList(rolesArray);
        
            } catch (error) {
                // console.log(error);
            }
        };
        getRoleData();
    }, [reloadDatatable])

    // Get injection guard data
    useEffect(() => {        
        setSearchQuery('');
        setActiveFilter('all'); // Reset the active role
        const getTableData = async () => {
            try {
                const response = await apiFetch({
                    path: '/ultimate-security/v1/url-guard',
                    method: 'GET'
                });    
                setTableData(response);
                setFilteredTableData(response);             
            } catch (error) {
                console.error(error);
            }
        };    
        getTableData();
    }, [reloadDatatable]);

    const handleSelectedRowsChange = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
    };

    const handleDatatableSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        setActiveFilter('all'); // Reset the active role
        const newData = tableData.filter(row => {
            // return row.param.toLowerCase().includes(query.toLowerCase());
            return (
                row.param.toLowerCase().includes(query) ||
                row.path.toLowerCase().includes(query) ||
                row.date.toLowerCase().includes(query)
            );
        });
        setFilteredTableData(newData);
    }

    const handleDatatableFilter = (status) => {
        setActiveFilter(status); // Set the active role
        setSearchQuery('');
        if (status === 'all') {
            setFilteredTableData(tableData);        
        } else {
            const newData = tableData.filter(row => {
                return row.blocked.toLowerCase().includes(status.toLowerCase());
            });
            setFilteredTableData(newData);        
        }
    }

    const handleBulkActionChange = (e) => {
        setBulkAction(e.target.value);
    };    

    const handleBulkActionSubmit = async () => {
        if (selectedRows.length) {
            const items = selectedRows.map(item => 
                item.id,
            );

            if (bulkAction !== "-1") {
                // console.log(items);
                const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
                if (confirmed) {
                    try {
                        const result = await formDataPost('requests_log_bulk_action',{"items": items, "flag": bulkAction});
                        // console.log(result);
                        if (result.success_message) {
                            setReloadDatatable(Math.random); 
                            setBulkAction("-1"); // Reset bulk action dropdown  
                            // console.log('xxx'); 
                            // Clear selected rows
                            setToggleCleared(!toggleCleared); // Toggle to trigger clear
                        }
                            
                    } catch (error) {
                        // console.log(error.message);
                    } finally {}
                }

            } else {
                alert("Please select a valid action.");
            }
            // setReloadDatatable(Math.random());
        } else {
            alert("Please select row.");
        }
    };
    // For data table
    return (
        <>

            <div className="setting-unit">
                {
                    roleList &&
                    <div className="row">
                        {
                            roleList.map(item => (                                        
                                item?.count ?
                                <div 
                                    key={item.role} 
                                    className='col-lg-4 col-md-6 col-sm-12 mb-4 role-item'
                                >
                                    <div className="border p-3 rounded-3">
                                        <h4 dangerouslySetInnerHTML={{ __html: item.count }} />
                                        <div dangerouslySetInnerHTML={{ __html: item.name }}/>
                                    </div>
                                    
                                </div> :''                                     
                            )) 
                        }
                    </div>
                }
                <div className="user-datatable datatable-unit pt-lg border-top">
                    <div className="row justify-content-between mb-30">
                        <div className="col-8 filters">
                            <div className="d-flex flex-wrap wp-roles">
                                {
                                    filterList && filterList.map(item => (                                        
                                        
                                        <span 
                                            key={item.role} 
                                            onClick={() => handleDatatableFilter(item.value)}
                                            className={activeFilter === item.value ? 'active' : ''}
                                        >
                                            {item.name} 
                                        </span> 
                                                                              
                                    ))      
                                }
                            </div>
                            <div className="bulk-action-wrapper">
                                <select value={bulkAction} name="action" onChange={handleBulkActionChange}>
                                    <option value="-1">{__('Bulk actions', 'ultimate-security')}</option>
                                    <option value="allow">{__('Allow', 'ultimate-security')}</option>
                                    <option value="blocked">{__('Blocked', 'ultimate-security')}</option>
                                </select>
                                <button className="button button-secondary" onClick={handleBulkActionSubmit}>{__('Apply', 'ultimate-security')}</button>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="search-unit d-flex gap-2 align-items-center">
                                <input 
                                    placeholder="Search" 
                                    type="search" 
                                    onChange={handleDatatableSearch} 
                                    value={searchQuery} 
                                />
                                <button className="button button-secondary" type="button">
                                    {__('Search', 'ultimate-security')}
                                </button>
                            </div>
                        </div>
                    </div>            
                    <div className="table-wrapper">
                        <DataTable
                            columns={columns}
                            data={filteredTableData} // Use filtered data
                            selectableRows
                            onSelectedRowsChange={handleSelectedRowsChange}
                            clearSelectedRows={toggleCleared}
                            pagination
                            paginationPerPage={15} // Default to 5 rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 25, 50, 100]} // Options with 5 first
                            dense
                            responsive
                        />
                    </div> 
                </div> 
            </div>
        </>
    )
}
export default withForm(SecurityInjectionGuardRequestsLog);